<template>
<svg width="7" height="10" viewBox="0 0 7 10" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
      d="M6.06507 5.27523C6.06507 5.43653 6.00349 5.59781 5.88057 5.72078L2.01073 9.59059C1.76456 9.83676 1.36544 9.83676 1.11937 9.59059C0.873297 9.34452 0.873297 8.94547 1.11937 8.69928L4.54362 5.27523L1.11949 1.85116C0.873417 1.60499 0.873417 1.20598 1.11949 0.959932C1.36556 0.713643 1.76468 0.713643 2.01085 0.959932L5.88069 4.82968C6.00363 4.95271 6.06507 5.11399 6.06507 5.27523Z"
      fill="#87939E"/>
</svg>
</template>
